<template>
  <div class="Kanit">
    <v-row>
      <v-col cols="4">
        <v-avatar size="90">
          <img :src="value.painter_info.profile_pic" />
        </v-avatar>
      </v-col>
      <v-col cols="8">
        <div style="color: #198cd0; font-weight: 600; font-size: 18px">
          {{ value.painter_info.name }}
        </div>
        <div style="font-size: x-small">
          <v-icon style="font-size: larger; color: #74c374; margin-right: 4px"
            >mdi-hammer-wrench</v-icon
          >
          ช่าง
        </div>
      </v-col>
    </v-row>
    <div>
      <v-divider></v-divider>
    </div>
    <div class="mt-5">
      <upload-multiple-file
        v-model="images"
        :max="100000"
        @onUploaded="onUploaded"
        :noShow="true"
        data-vv-name="uploadMultipleFile"
        data-vv-as="Preview Image"
      ></upload-multiple-file>
    </div>
    <div class="pb-16" v-if="!loading">
      <v-row dense>
        <v-col v-for="(img, k) in painterImg" :key="img + k" cols="4">
          <v-img
            @click="
              showimg = img;
              showimgdialog = true;
            "
            aspect-ratio="1.3"
            class="grey darken-2"
            :src="img"
            :lazy-src="img"
          ></v-img>
        </v-col>
      </v-row>
      <v-dialog v-model="showimgdialog">
        <div v-if="showimgdialog">
          <v-img
            @click="
              showimgdialog = false;
              showimg = '';
            "
            class="grey darken-2"
            :src="showimg"
            :lazy-src="showimg"
          ></v-img>
        </div>
      </v-dialog>
    </div>
    <div v-else class="text-center pt-9">
      <v-progress-circular
        indeterminate
        color="primary"
        size="70"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UploadMultipleFile from "@/components/UpdateMultipleFileUpdateProgress.vue";

export default {
  props: ["value"],
  data() {
    return {
      showimg: "",
      showimgdialog: false,
      loading: "",
      images: [],
      painterImg: [],
    };
  },
  components: {
    UploadMultipleFile,
  },
  async mounted() {
    this.loading = true;
    await this.getPhoto();
    this.loading = false;
  },
  methods: {
    getPhoto() {
      return new Promise((resolve) => {
        var vm = this;
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toapainterworks", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: vm.query.pageid,
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              if (
                response &&
                response.data &&
                response.data.data &&
                response.data.data[0] &&
                response.data.data[0].data
              ) {
                vm.painterImg = response.data.data[0].data;
              } else {
                vm.painterImg = [];
              }
              resolve();
            }
            resolve();
          });
      });
    },
    onUploaded(val) {
      var vm = this;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: vm.query.pageid,
        works: val,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toapainterworks",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then((response) => {
          if (response.data.responsecode == 200) {
            this.painterImg.push(...val);
            this.images = [];
          }
        });
    },
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
  },
};
</script>
